module.exports = __webpack_public_path__ + "img/335.1a758b1f.jpg";